import type { ButtonAction, WidgetMessage } from "Cobalt/ChatWidget";

import type { ConciergeActions } from "./actions";
import type { ConciergeStep } from "./conciergeChat.types";

type Catalog = ConciergeActions["catalog"];

// Resolve a feature id to a button, or null when it has no catalog entry — an
// unknown or non-actionable id (e.g. live_chat, sbc) simply renders nothing.
function toButton(catalog: Catalog, featureId: string): ButtonAction | null {
  const entry = catalog[featureId];
  return entry ? { id: featureId, label: entry.label } : null;
}

// One persisted step -> the widget's message shape. Buttons come from the step's
// feature ids resolved against the domain catalog; user turns carry none.
export function formatStep(catalog: Catalog, step: ConciergeStep): WidgetMessage {
  const buttons = step.features.map((id) => toButton(catalog, id)).filter((b): b is ButtonAction => b !== null);
  return {
    id: String(step.id),
    role: step.role,
    text: step.text,
    ...(buttons.length > 0 && { buttons }),
  };
}

export function formatTranscript(catalog: Catalog, steps: ConciergeStep[]): WidgetMessage[] {
  return steps.map((step) => formatStep(catalog, step));
}
